module.exports = __webpack_public_path__ + "static/media/supervisor-handover-alt.2fa884bf.svg";